import { create } from 'zustand';

interface Heading {
  label: string;
  link: string;
  id: string;
  scrollLink?: string;
}

interface HeaderStore {
  activeItem: number;
  headings: Heading[];
}

const useTocStore = create<HeaderStore>(() => ({
  activeItem: 0,
  headings: [],
}));

export const setActiveItem = (item: number) => useTocStore.setState({ activeItem: item });
export const setHeadings = (headings: Heading[]) => useTocStore.setState({ headings });

export default useTocStore;
